import { View } from "../../Base";
import { ClockIcon } from "../../Icons";
import clsx from "clsx";
import React from "react";
import { makeStyles } from "@mui/styles";
import { palette } from "../../../theme/palette";
import OpportunityTimePopover from "./OpportunityPopover";
import { useSelector } from "react-redux";
import { dutyAndOpportunityRoutesSelector } from "../../../reducers/matrixProfile/selectors";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  infoIcon: {
    margin: "0 4px 0 15px",
    fill: palette.typography.white.high,
    cursor: "pointer",
  },
  clockIcon: {
    width: "16px",
    height: "16px",
  },
  fillOrange: {
    fill: palette.orange,
  },
}));

const OpportunityTimeComponent = () => {
  const styles = useStyles();

  const [clockAnchorEl, setClockWarningAnchorEl] = React.useState(null);
  const dutyOpportunityRoutes = useSelector(dutyAndOpportunityRoutesSelector);

  return (
    <View className={styles.container}>
      <ClockIcon
        className={clsx(
          styles.infoIcon,
          styles.clockIcon,
          clockAnchorEl ? styles.fillOrange : null
        )}
        onClick={(event) =>
          dutyOpportunityRoutes?.opportunity?.length &&
          setClockWarningAnchorEl(event.currentTarget)
        }
      />
      {dutyOpportunityRoutes?.opportunity?.length || 0}
      <OpportunityTimePopover
        open={!!clockAnchorEl}
        onClose={() => setClockWarningAnchorEl(null)}
        anchorEl={clockAnchorEl}
      />
    </View>
  );
};

export default OpportunityTimeComponent;
